import { BrowserModule } from '@angular/platform-browser';
import { NgModule, ErrorHandler } from '@angular/core';
import { IonicApp, IonicModule, IonicErrorHandler } from 'ionic-angular';
import { Network } from '@ionic-native/network';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { HttpClientModule } from '@angular/common/http';
import { MyApp } from './app.component';
import {FormsModule} from '@angular/forms';

import { StartUpPage } from '../pages/startup/startup';
import { LoginPage } from '../pages/login/login';
import { HomePage } from '../pages/home/home';
import { VisitorsRegPage } from '../pages/visitors-reg/visitors-reg';
import { VisitorsRegMorePage } from '../pages/visitors-reg-more/visitors-reg-more';
import { VisitorsRegDisclaimerPage } from '../pages/visitors-reg-disclaimer/visitors-reg-disclaimer';
import { VisitorsPreRegPage } from '../pages/visitors-prereg/visitors-prereg';
import { CalendarPage } from '../pages/calendar/calendar';
import { VideoPage } from '../pages/video/video';
import { ForgotPage } from '../pages/forgot/forgot';
import { DirectionsPage } from '../pages/directions/directions';
import { ResetpwdPage } from '../pages/resetpwd/resetpwd';
import { SecurityhomePage } from '../pages/securityhome/securityhome';
import { CheckinPage } from '../pages/checkin/checkin';
import { ReactivatePage } from '../pages/reactivate/reactivate';
import { ReactivateotpPage } from '../pages/reactivateotp/reactivateotp';
import { ViewvisitorPage } from '../pages/viewvisitor/viewvisitor';
import { VisitoreditPage } from '../pages/visitoredit/visitoredit';
import { VisitorreportPage } from '../pages/visitorreport/visitorreport';

import { IonicStorageModule, Storage } from '@ionic/storage';
import { StatusBar } from '@ionic-native/status-bar';
import { SplashScreen } from '@ionic-native/splash-screen';

import { ImagePicker } from '@ionic-native/image-picker';
import { Base64 } from '@ionic-native/base64';

import { File } from '@ionic-native/file';
import { Transfer } from '@ionic-native/transfer';
import { FilePath } from '@ionic-native/file-path';
import { Camera } from '@ionic-native/camera';
import { DatePicker } from '@ionic-native/date-picker';
import { GlobalProvider } from '../providers/global/global';
import { ImageBrowserUploadProvider } from '../providers/image-browser-upload/image-browser-upload';

const storage = new Storage({
  name: '_transnet',
  driverOrder: ['sqlite', 'indexeddb', 'websql'],
});

/*
export function jwtOptionsFactory(storage) {
  console.log('on jwt fncall = '+storage.get('Authorization'));
  return {
    tokenGetter: () => {
      return storage.get('Authorization');
    },
    whitelistedDomains: ['localhost:8080']
  }
}*/

@NgModule({
  declarations: [
    MyApp,
    StartUpPage,
    LoginPage,
    HomePage,
    VisitorsRegPage,
    VisitorsRegMorePage,
    VisitorsRegDisclaimerPage,
    VisitorsPreRegPage,
    CalendarPage,
    VideoPage,
    ForgotPage,
    ResetpwdPage,
    DirectionsPage,
    SecurityhomePage,
    CheckinPage,
    ReactivatePage,
    ReactivateotpPage,
    ViewvisitorPage,
    VisitoreditPage,
    VisitorreportPage
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    FormsModule,
    IonicModule.forRoot(MyApp),
    IonicStorageModule.forRoot({
      name: '_transnet',
      driverOrder: ['indexeddb', 'sqlite', 'websql']
    }),/*
    JwtModule.forRoot({
      jwtOptionsProvider: {
        provide: JWT_OPTIONS,
        useFactory: jwtOptionsFactory,
        deps: [Storage]
      }
    })*/
  ],
  bootstrap: [IonicApp],
  entryComponents: [
    MyApp,
    StartUpPage,
    LoginPage,
    HomePage,
    ReactivatePage,
    ReactivateotpPage,
    VisitorsRegPage,
    VisitorsRegMorePage,
    VisitorsRegDisclaimerPage,
    VisitorsPreRegPage,
    CalendarPage,
    VideoPage,
    ForgotPage,
    ResetpwdPage,
    DirectionsPage,
    SecurityhomePage,
    CheckinPage,
    ViewvisitorPage,
    VisitoreditPage,
    VisitorreportPage
  ],
  providers: [
    StatusBar,
    SplashScreen,
    HttpClientModule,
    IonicStorageModule,
    {provide: ErrorHandler, useClass: IonicErrorHandler},
    ImagePicker,
    Base64,
    File,
    Transfer,
    Camera,
    DatePicker,
    Network,
    FilePath,
    GlobalProvider,
    ImageBrowserUploadProvider,
  ]
})
export class AppModule {}



// WEBPACK FOOTER //
// ./src/app/app.module.ts